import React from "react";
import Logo from "../../../static/images/vivacom/vivacom_logo_negative.png";
import LogoSvg from "../../../static/images/vivacom/vivacom_white.svg";
import ProductsService from "../../services/ProductsService";
import IconGO from "../../../static/images/vivacom/navbar_menu/GO_icon.svg";
import IconCSC from "../../../static/images/vivacom/navbar_menu/Kasko_icon.svg";
import IconTRA from "../../../static/images/vivacom/navbar_menu/Travel_icon.svg";
import IconPRP from "../../../static/images/vivacom/navbar_menu/Imushtestvo_icon.svg";
import IconMTN from "../../../static/images/vivacom/navbar_menu/Planinska_icon.svg";
import IconEXT from "../../../static/images/vivacom/navbar_menu/Ekstremni_icon.svg";

const mainProducts = [
  {
    id: "GO",
    title: language => ProductsService.getProductName("GO", language),
    price: "Compare prices and save",
    link: "/grazhdanska-otgovornost-online/",
    checklist: ["Избор от 6 застрахователя", "See prices in just 30 seconds", "Free Shipping"],
    successfulPurchaseMessage: "",
    couriers: ["econt"],
    insurers: [
      {
        id: "allianz",
        paymentModes: ["1"],
        documents: [
          {
            id: "helpUrl",
            label: "Помощ при застрахователно събитие за Гражданска отговорност",
            labelEn: "Assistance in the Event of an Insured Event for Civil Liability",
            url: "https://docs.boleron.bg/documents-vivacom/grazhdanska-otgovornost-pomosht-pri-zastrahovatelno-sabitie.pdf"
          }
        ]
      },
      {
        id: "bulstrad",
        paymentModes: ["1"],
        documents: [
          {
            id: "helpUrl",
            label: "Помощ при застрахователно събитие за Гражданска отговорност",
            labelEn: "Assistance in the Event of an Insured Event for Civil Liability",
            url: "https://docs.boleron.bg/documents-vivacom/grazhdanska-otgovornost-pomosht-pri-zastrahovatelno-sabitie.pdf"
          },
          {
            id: "euDocumentUrl",
            label: "ЗЕАД Булстрад Виена Иншурънс Груп - Информационен документ за Гражданска отговорност (IPID, PDF)",
            labelEn: "Bulstrad Vienna Insurance Group – Information Document for Civil Liability (IPID, PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/bulstrad-grazhdanska-otgovornost-ipid.pdf"
          }
        ]
      },
      {
        id: "dzi",
        paymentModes: ["1"],
        documents: [
          {
            id: "helpUrl",
            label: "Помощ при застрахователно събитие за Гражданска отговорност",
            labelEn: "Assistance in the Event of an Insured Event for Civil Liability",
            url: "https://docs.boleron.bg/documents-vivacom/grazhdanska-otgovornost-pomosht-pri-zastrahovatelno-sabitie.pdf"
          },
          {
            id: "euDocumentUrl",
            label: "ДЗИ - Общо застраховане ЕАД - Информационен документ за Гражданска отговорност (IPID, PDF)",
            labelEn: "DZI - General Insurance EAD – Information Document for Civil Liability (IPID, PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/dzi-grazhdanska-otgovornost-ipid.pdf"
          }
        ]
      },
      {
        id: "euroins",
        paymentModes: ["1"],
        documents: [
          {
            id: "helpUrl",
            label: "Помощ при застрахователно събитие за Гражданска отговорност",
            labelEn: "Assistance in the Event of an Insured Event for Civil Liability",
            url: "https://docs.boleron.bg/documents-vivacom/grazhdanska-otgovornost-pomosht-pri-zastrahovatelno-sabitie.pdf"
          },
          {
            id: "euDocumentUrl",
            label: "ЗД Евроинс АД - Информационен документ за Гражданска отговорност (IPID, PDF)",
            labelEn: "Euroins AD – Information Document for Civil Liability (IPID, PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/euroins-grazhdanska-otgovornost-ipid.pdf"
          }
        ]
      },
      {
        id: "levins",
        paymentModes: ["1"],
        documents: [
          {
            id: "helpUrl",
            label: "Помощ при застрахователно събитие за Гражданска отговорност",
            labelEn: "Assistance in the Event of an Insured Event for Civil Liability",
            url: "https://docs.boleron.bg/documents-vivacom/grazhdanska-otgovornost-pomosht-pri-zastrahovatelno-sabitie.pdf"
          },
          {
            id: "euDocumentUrl",
            label: "ЗК Лев Инс АД - Информационен документ за Гражданска отговорност (IPID, PDF)",
            labelEn: "Lev Ins AD – Information Document for Civil Liability (IPID, PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/levins-grazhdanska-otgovornost-ipid.pdf"
          }
        ]
      },
      {
        id: "uniqa",
        paymentModes: ["1"],
        documents: [
          {
            id: "helpUrl",
            label: "Помощ при застрахователно събитие за Гражданска отговорност",
            labelEn: "Assistance in the Event of an Insured Event for Civil Liability",
            url: "https://docs.boleron.bg/documents-vivacom/grazhdanska-otgovornost-pomosht-pri-zastrahovatelno-sabitie.pdf"
          },
          {
            id: "euDocumentUrl",
            label: "ЗК УНИКА АД - Информационен документ за Гражданска отговорност (IPID, PDF)",
            labelEn: "UNIQA AD – Information Document for Civil Liability (IPID, PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/uniqa-grazhdanska-otgovornost-ipid.pdf"
          }
        ]
      }
    ]
  },
  {
    id: "CSC",
    title: language => ProductsService.getProductName("CSC", language),
    price: "VivacomPricesFromBGN249",
    link: "/kasko-kalkulator/",
    checklist: ["Онлайн калкулатор", "Automatic market valuation", "You get the policy right away"],
    successfulPurchaseMessage: "",
    couriers: ["econt"],
    offlineOffer: false,
    insurers: [
      {
        id: "bulstrad",
        hasPrice: true,
        hasPromoCode: true,
        documents: [
          {
            id: "termsUrl",
            label: "Общи условия по застраховка Каско (PDF)",
            labelEn: "General Terms and Conditions for Casco Insurance (PDF)",
            url: "https://docs.boleron.bg/boleron/bulstrad-kasko-obsti-usloviya-2024-02-12.PDF"
          },
          {
            id: "euDocumentUrl",
            label: "Информационен документ за застрахователен продукт Каско (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Casco Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/boleron/bulstrad-kasko-ipid.pdf"
          },
          {
            id: "euDocumentGOUrl",
            label: "ЗЕАД Булстрад Виена Иншурънс Груп - Информационен документ за Гражданска отговорност (IPID, PDF)",
            labelEn: "Bulstrad Vienna Insurance Group – Information Document for Civil Liability (IPID, PDF)",
            url: "https://docs.boleron.bg/boleron/bulstrad-grazhdanska-otgovornost-ipid.pdf"
          },
          {
            id: "predogUrl",
            label: "Преддоговорна информация за застраховка Каско (PDF)",
            labelEn: "Pre-Contractual Information for Casco Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/bulstrad-preddogovorna-informaciya.pdf"
          },
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по Каско (PDF)",
            labelEn: "Information in the Event of a Casco Insurance Claim (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/bulstrad-kasko-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      },
      {
        id: "euroins",
        hasPrice: true,
        hasPromoCode: true,
        documents: [
          {
            id: "termsUrl",
            label: "Общи условия по застраховка Каско (PDF)",
            labelEn: "General Terms and Conditions for Casco Insurance (PDF)",
            url: "https://docs.boleron.bg/boleron/euroins-kasko-obsti-usloviya-2025-06-01.pdf"
          },
          {
            id: "euDocumentUrl",
            label: "Информационен документ за застрахователен продукт Каско (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Casco Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/boleron/euroins-kasko-ipid.pdf"
          },
          {
            id: "euDocumentGOUrl",
            label: "ЗД Евроинс АД - Информационен документ за Гражданска отговорност (IPID, PDF)",
            labelEn: "Euroins AD – Information Document for Civil Liability (IPID, PDF)",
            url: "https://docs.boleron.bg/boleron/euroins-grazhdanska-otgovornost-ipid.pdf"
          },
          // {
          //   id: "predogUrl",
          //   label: "Преддоговорна информация за застраховка Каско (PDF)",
          //   labelEn: "Pre-Contractual Information for Casco Insurance (PDF)",
          //   url: "https://docs.boleron.bg/documents-vivacom/EUROINS_PDOG.pdf"
          // },//todo липсва
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по Каско (PDF)",
            labelEn: "Information in the Event of a Casco Insurance Claim (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/euroins-kasko-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      },
      {
        id: "levins",
        hasPrice: true,
        hasPromoCode: true,
        documents: [
          {
            id: "termsUrl",
            label: "Общи условия по застраховка Каско (PDF)",
            labelEn: "General Terms and Conditions for Casco Insurance (PDF)",
            url: "https://docs.boleron.bg/boleron/levins-kasko-obsti-usloviya-2026-07-20.pdf"
          },
          {
            id: "specialTermsUrl",
            label: "Специални условия по застраховка Каско (PDF)",
            labelEn: "Special Terms and Conditions for Casco Insurance (PDF)",
            url: "https://docs.boleron.bg/boleron/levins-kasko-specialni-usloviya-2026-07-20.pdf"
          },
          {
            id: "euDocumentUrl",
            label: "Информационен документ за застрахователен продукт Каско (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Casco Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/boleron/levins-kasko-ipid.pdf"
          },
          {
            id: "trustedServiceCentersList",
            label: "Карта с доверени сервизи (PDF)",
            labelEn: "Trusted Service Centers Map (PDF)",
            url: "https://www.google.com/maps/d/viewer?mid=153NzCRsbplS1WsuK3leVhfCFSPs&hl=bg&ll=42.84265560196353%2C26.26353200078126&z=7"
          },
          // {
          //   id: "predogUrl",
          //   label: "Преддоговорна информация за застраховка Каско (PDF)",
          //   labelEn: "Pre-Contractual Information for Casco Insurance (PDF)",
          //   url: "https://docs.boleron.bg/documents-vivacom/LEVINS_PDOG.pdf"
          // }, //todo липсва такъв документ
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по Каско (PDF)",
            labelEn: "Information in the Event of a Casco Insurance Claim (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/levins-kasko-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      }
    ]
  },

  {
    id: "TRA",
    title: language => ProductsService.getProductName("TRA", language),
    price: "VivacomPricesFromBGN2",
    link: "/zastrahovka-patuvane-v-chuzhbina/",
    checklist: ["Covers treatment up to €50,000", "You get the policy right away", "24/7 worldwide support"],
    successfulPurchaseMessage: "",
    couriers: ["econt"],
    insurers: [
      {
        id: "bulstrad",
        hasPromoCode: true,
        documents: [
          {
            id: "euDocumentUrl",
            label: "Информационен документ за застраховка Пътуване в Чужбина (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Travel Abroad Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/bulstrad-patuvane-v-chuzhbina-ipid.pdf"
          },
          {
            id: "termsUrl",
            label: "Общи условия по застраховка Пътуване в Чужбина (PDF)",
            labelEn: "General Terms and Conditions for Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/bulstrad-patuvane-v-chuzhbina-obsti-usloviya-2022-06-06.pdf"
          },
          {
            id: "predogUrl",
            label: "Преддоговорна информация за застраховка Пътуване в Чужбина (PDF)",
            labelEn: "Pre-contractual Information for Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/bulstrad-preddogovorna-informaciya.pdf"
          },
          {
            id: "userInsuranceInfo",
            label: "Информация за ползвателя на застрахователни услуги",
            labelEn: "Information for the User of Insurance Services",
            url: "https://docs.boleron.bg/documents-vivacom/vivacom-informatsiya-zastrahovatelni-uslugi.pdf"
          },
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по застраховка Пътуване в Чужбина (PDF)",
            labelEn: "Information in the Event of an Insured Event under Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/bulstrad-patuvane-v-chuzhbina-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      },
      {
        id: "levins",
        hasPromoCode: true,
        documents: [
          {
            id: "euDocumentUrl",
            label: "Информационен документ за застраховка Пътуване в Чужбина (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Travel Abroad Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/euroins-patuvane-v-chuzhbina-ipid.pdf"
          },
          {
            id: "termsUrl",
            label: "Общи условия по застраховка Пътуване в Чужбина (PDF)",
            labelEn: "General Terms and Conditions for Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/levins-patuvane-v-chuzhbina-obsti-usloviya-2023-05-09.pdf"
          },
          // {
          //   id: "predogUrl",
          //   label: "Преддоговорна информация за застраховка Пътуване в Чужбина (PDF)",
          //   labelEn: "Pre-contractual Information for Travel Abroad Insurance (PDF)",
          //   url: "#"
          // },
          {
            id: "userInsuranceInfo",
            label: "Информация за ползвателя на застрахователни услуги",
            labelEn: "Information for the User of Insurance Services",
            url: "https://docs.boleron.bg/documents-vivacom/vivacom-informatsiya-zastrahovatelni-uslugi.pdf"
          },
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по застраховка Пътуване в Чужбина (PDF)",
            labelEn: "Information in the Event of an Insured Event under Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/levins-patuvane-v-chuzhbina-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      },
      {
        id: "euroins",
        hasPromoCode: true,
        documents: [
          {
            id: "euDocumentUrl",
            label: "Информационен документ за застраховка Пътуване в Чужбина (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Travel Abroad Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/instinct-patuvane-v-chuzhbina-ipid.pdf"
          },
          {
            id: "termsUrl",
            label: "Общи условия по застраховка Пътуване в Чужбина (PDF)",
            labelEn: "General Terms and Conditions for Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/euroins-patuvane-v-chuzhbina-obsti-usloviya-2024-10-01.pdf"
          },
          {
            id: "predogUrl",
            label: "Преддоговорна информация за застраховка Пътуване в Чужбина (PDF)",
            labelEn: "Pre-contractual Information for Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/euroins-preddogovorna-informaciya.pdf"
          },
          {
            id: "userInsuranceInfo",
            label: "Информация за ползвателя на застрахователни услуги",
            labelEn: "Information for the User of Insurance Services",
            url: "https://docs.boleron.bg/documents-vivacom/vivacom-informatsiya-zastrahovatelni-uslugi.pdf"
          },
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по застраховка Пътуване в Чужбина (PDF)",
            labelEn: "Information in the Event of an Insured Event under Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/euroins-patuvane-v-chuzhbina-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      },
      {
        id: "instinct",
        hasPromoCode: true,
        paymentModes: ["1"],
        documents: [
          {
            id: "euDocumentUrl",
            label: "Информационен документ за застраховка Пътуване в Чужбина (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Travel Abroad Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/levins-patuvane-v-chuzhbina-ipid.pdf"
          },
          {
            id: "termsUrl",
            label: "Общи условия по застраховка Пътуване в Чужбина (PDF)",
            labelEn: "General Terms and Conditions for Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/instinct-patuvane-v-chuzhbina-obsti-usloviya-2026-08-09.pdf"
          },
          {
            id: "predogUrl",
            label: "Преддоговорна информация за застраховка Пътуване в Чужбина (PDF)",
            labelEn: "Pre-contractual Information for Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/instinct-preddogovorna-informaciya.pdf"
          },
          {
            id: "uvpUrl",
            label: "Уведомление за поверителност",
            labelEn: "Privacy Notice",
            url: "https://docs.boleron.bg/documents-vivacom/instinct-patuvane-v-chuzhbina-uvedomlenie-za-poveritelnost.pdf"
          },
          {
            id: "userInsuranceInfo",
            label: "Информация за ползвателя на застрахователни услуги",
            labelEn: "Information for the User of Insurance Services",
            url: "https://docs.boleron.bg/documents-vivacom/vivacom-informatsiya-zastrahovatelni-uslugi.pdf"
          },
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по застраховка Пътуване в Чужбина (PDF)",
            labelEn: "Information in the Event of an Insured Event under Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/instinct-patuvane-v-chuzhbina-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      },
      {
        id: "uniqa",
        hasPromoCode: true,
        documents: [
          {
            id: "euDocumentUrl",
            label: "Информационен документ за застраховка Пътуване в Чужбина (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Travel Abroad Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/uniqa-patuvane-v-chuzhbina-ipid.pdf"
          },
          {
            id: "termsUrl",
            label: "Общи условия по застраховка Пътуване в Чужбина (PDF)",
            labelEn: "General Terms and Conditions for Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/uniqa-patuvane-v-chuzhbina-obsti-usloviya-2025-08-08.pdf"
          },
          {
            id: "predogUrl",
            label: "Преддоговорна информация за застраховка Пътуване в Чужбина (PDF)",
            labelEn: "Pre-contractual Information for Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/uniqa-preddogovorna-informaciya.pdf"
          },
          {
            id: "uvpUrl",
            label: "Уведомление за поверителност",
            labelEn: "Privacy Notice",
            url: "https://docs.boleron.bg/documents-vivacom/uniqa-patuvane-v-chuzhbina-uvedomlenie-za-poveritelnost.pdf"
          },
          {
            id: "userInsuranceInfo",
            label: "Информация за ползвателя на застрахователни услуги",
            labelEn: "Information for the User of Insurance Services",
            url: "https://docs.boleron.bg/documents-vivacom/vivacom-informatsiya-zastrahovatelni-uslugi.pdf"
          },
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по застраховка Пътуване в Чужбина (PDF)",
            labelEn: "Information in the Event of an Insured Event under Travel Abroad Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/uniqa-patuvane-v-chuzhbina-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      }
    ]
  },
  {
    id: "PRP",
    title: language => ProductsService.getProductName("PRP", language),
    price: "VivacomPricesFromBGN999",
    link: "/zastrahovka-imushtestvo/",
    checklist: ["Fire, flood, earthquake", "Automatic monthly payment", "Completely online, paperless"],
    successfulPurchaseMessage: "",
    couriers: ["econt"],
    insurers: [
      {
        id: "uniqa",
        hasPromoCode: true,
        documents: [
          {
            id: "termsUrl",
            label: "Общи условия по застраховка Имущество (PDF)",
            labelEn: "General Terms and Conditions for Property Insurance (PDF)",
            url: "https://docs.boleron.bg/boleron/uniqa-zastrahovka-imushtestvo-obsti-usloviya-2024-02-01.pdf"
          },
          {
            id: "euDocumentUrl",
            label: "Информационен документ за застраховка Имущество (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Property Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/boleron/uniqa-zastrahovka-imushtestvo-ipid.pdf"
          },
          {
            id: "predogUrl",
            label: "Преддоговорна информация за застраховка Имущество (PDF)",
            labelEn: "Pre-contractual Information for Property Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/uniqa-preddogovorna-informaciya.pdf"
          },
          {
            id: "additionalTermsUrl",
            label: "Специални условия по застраховка Имущество (PDF)",
            labelEn: "Special Terms and Conditions for Property Insurance (PDF)",
            url: "https://docs.boleron.bg/boleron/uniqa-zastrahovka-imushtestvo-specialni-usloviya-2026-01-01.pdf"
          },
          {
            id: "assistanceTermsUrl",
            label: 'Клауза "Домашен асистанс"',
            labelEn: '"Home Assistance" Clause',
            url: "https://docs.boleron.bg/boleron/uniqa-zastrahovka-imushtestvo-klauza-domashen-asistans.pdf"
          },
          {
            id: "goTermsUrl",
            label: 'ОУ "Обща Гражданска Отговорност"',
            labelEn: '"General Civil Liability" General Terms and Conditions',
            url: "https://docs.boleron.bg/boleron/uniqa-zastrahovka-imushtestvo-obshta-grazhdanska-otgovornost.pdf"
          }, // само ако е избран чека в допълнителни покрития
          {
            id: "userInsuranceInfo",
            label: "Информация за ползвателя на застрахователни услуги",
            labelEn: "Information for the User of Insurance Services",
            url: "https://docs.boleron.bg/documents-vivacom/vivacom-informatsiya-zastrahovatelni-uslugi.pdf"
          },
          {
            id: "uvpUrl",
            label: "Уведомление за поверителност",
            labelEn: "Privacy Notice",
            url: "https://docs.boleron.bg/boleron/uniqa-zastrahovka-imushtestvo-uvedomlenie-za-poveritelnost.pdf"
          },
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по застраховка Имущество (PDF)",
            labelEn: "Information in the Event of an Insurance Claim under Property Insurance (PDF)",
            url: "https://docs.boleron.bg/boleron/uniqa-zastrahovka-imushtestvo-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      },
      {
        id: "bulstrad",
        hasPromoCode: true,
        documents: [
          {
            id: "termsUrl",
            label: "Общи условия по застраховка Имущество (PDF)",
            labelEn: "General Terms and Conditions for Property Insurance (PDF)",
            url: "https://docs.boleron.bg/boleron/bulstrad-zastrahovka-imushtestvo-specialni-usloviya-2026-01-01.pdf"
          },
          {
            id: "euDocumentUrl",
            label: "Информационен документ за застраховка Имущество (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Property Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/boleron/bulstrad-zastrahovka-imushtestvo-ipid.pdf"
          },
          {
            id: "predogUrl",
            label: "Преддоговорна информация за застраховка Имущество (PDF)",
            labelEn: "Pre-contractual Information for Property Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/bulstrad-preddogovorna-informaciya.pdf"
          },
          {
            id: "userInsuranceInfo",
            label: "Информация за ползвателя на застрахователни услуги",
            labelEn: "Information for the User of Insurance Services",
            url: "https://docs.boleron.bg/documents-vivacom/vivacom-informatsiya-zastrahovatelni-uslugi.pdf"
          },
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по застраховка Имущество (PDF)",
            labelEn: "Information in the Event of an Insurance Claim under Property Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/bulstrad-zastrahovka-imushtestvo-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      }
    ]
  },
  {
    id: "MTN",
    title: language => ProductsService.getProductName("MTN", language),
    price: "VivacomPricesFromBGN4",
    link: "/planinska-zastrahovka/",
    checklist: ["Rescue and medical expenses", "Completely online, paperless", "You get the policy right away"],
    successfulPurchaseMessage: "",
    couriers: ["econt"],
    insurers: [
      {
        id: "euroins",
        hasPromoCode: true,
        documents: [
          {
            id: "termsUrl",
            label: "Общи условия по Планинска Застраховка (PDF)",
            labelEn: "General Terms and Conditions for Mountain Insurance (PDF)",
            url: "https://docs.boleron.bg/boleron/euroins-planinska-zastrahovka-obsti-usloviya-2021-11-22.pdf"
          },
          {
            id: "euDocumentUrl",
            label: "Информационен документ за Планинска Застраховка (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Mountain Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/boleron/euroins-planinska-zastrahovka-ipid.pdf"
          },
          {
            id: "predogUrl",
            label: "Преддоговорна информация за Планинска Застраховка (PDF)",
            labelEn: "Pre-contractual Information for Mountain Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/euroins-preddogovorna-informaciya.pdf"
          },
          {
            id: "userInsuranceInfo",
            label: "Информация за ползвателя на застрахователни услуги",
            labelEn: "Information for the User of Insurance Services",
            url: "https://docs.boleron.bg/documents-vivacom/vivacom-informatsiya-zastrahovatelni-uslugi.pdf"
          },
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по Планинска Застраховка (PDF)",
            labelEn: "Information in the Event of an Insurance Claim under Mountain Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/euroins-planinska-zastrahovka-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      }
    ]
  },
  {
    id: "EXT",
    title: language => ProductsService.getProductName("EXT", language),
    price: "VivacomPricesFromBGN12",
    link: "/zastrahovka-ekstremni-sportove/",
    checklist: ["Rescue and medical expenses", "Completely online, paperless", "You get the policy right away"],
    successfulPurchaseMessage: "",
    couriers: ["econt"],
    insurers: [
      {
        id: "euroins",
        hasPromoCode: true,
        documents: [
          {
            id: "termsUrl",
            label: "Общи условия по застраховка Екстремни спортове (PDF)",
            labelEn: "General Terms and Conditions for Extreme Sports Insurance (PDF)",
            url: "https://docs.boleron.bg/boleron/euroins-planinska-zastrahovka-obsti-usloviya-2021-11-22.pdf"
          },
          {
            id: "euDocumentUrl",
            label: "Информационен документ за застраховка Екстремни спортове (IPID, PDF)",
            labelEn: "Insurance Product Information Document for Extreme Sports Insurance (IPID, PDF)",
            url: "https://docs.boleron.bg/boleron/euroins-planinska-zastrahovka-ipid.pdf"
          },
          {
            id: "predogUrl",
            label: "Преддоговорна информация за застраховка Екстремни спортове (PDF)",
            labelEn: "Pre-contractual Information for Extreme Sports Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/euroins-preddogovorna-informaciya.pdf"
          },
          {
            id: "userInsuranceInfo",
            label: "Информация за ползвателя на застрахователни услуги",
            labelEn: "Information for the User of Insurance Services",
            url: "https://docs.boleron.bg/documents-vivacom/vivacom-informatsiya-zastrahovatelni-uslugi.pdf"
          },
          {
            id: "helpUrl",
            label: "Информация при застрахователно събитие по застраховка Екстремни спортове (PDF)",
            labelEn: "Information in the Event of an Insurance Claim under Extreme Sports Insurance (PDF)",
            url: "https://docs.boleron.bg/documents-vivacom/euroins-zastrahovka-ekstremni-sportove-informatsiya-zastrahovatelno-sabitie.pdf"
          }
        ]
      }
    ]
  }
];
const onlineProducts = [];

const marketingText = "Съгласен ли си да получаваш от Vivacom оферти, намаления, промоции и подаръци?";

const header = {
  logo: <img style={{ width: 250, marginTop: 9 }} src={Logo} alt="logo" />,
  logoText: {
    disabled: true
  },
  links: [
    { id: "home", url: "/" },
    { id: "insurances", url: "" },
    { id: "services", disabled: true },
    { id: "aboutUs", url: "/about-us", disabled: true },
    { id: "contacts", url: "/contacts", disabled: true },
    { id: "myProfile", url: "/policies", disabled: false },
    { id: "blog", url: "/blog", disabled: true },
    { id: "bottomLogo", url: "/", disabled: false }
  ],
  downloadApp: {
    disabled: true
  },
  hr: {
    disabled: false
  }
};
const footer = {
  logo: <LogoSvg className="logo-footer" style={{ marginTop: -8 }} />,
  logoText: {
    disabled: true
  },
  sectionMenu: {
    disabled: true
  },
  sectionMessage: {
    disabled: true
  },
  sectionSocialMedia: {
    disabled: true
  },
  phone: {
    text: "0897 659 173",
    link: "+359897659173",
    isIconDissabled: true
  },
  email: {
    text: "support-insurance@vivacom.bg",
    isIconDissabled: true
  },
  hr: {
    disabled: false
  },
  isoSection: {
    disabled: true
  },
  footerText: {
    isCentered: false,
    paddingStyles: "pl-5 pr-2"
  }
};

const productImages = [
  {
    product: "GO",
    image: (
      <div className="boleron-index-icon-wrapper">
        <img src="/images/vivacom/landing/go.svg" alt="vivacom-index-icon-go" className="vivacom-index-icon" />
        <div className="product-hr-vivacom" />
      </div>
    )
  },
  {
    product: "CSC",
    image: (
      <div className="is-flex is-align-items-center is-justify-content-center h-100 is-flex-direction-column is-primary-color">
        <img src="/images/vivacom/landing/csc.svg" alt="vivacom-index-icon-csc" className="vivacom-index-icon" />
        <div className="product-hr-vivacom" />
      </div>
    )
  },
  {
    product: "TRA",
    image: (
      <div className="is-flex is-align-items-center is-justify-content-center h-100 is-flex-direction-column is-primary-color">
        {/* <img src="/images/vivacom/landing/tra_icon_discount.svg" alt="vivacom-index-icon-tra" className="vivacom-index-icon" /> */}
        <img src="/images/vivacom/landing/tra.svg" alt="vivacom-index-icon-tra" className="vivacom-index-icon" />
        <div className="product-hr-vivacom" />
      </div>
    )
  },
  {
    product: "PRP",
    image: (
      <div className="boleron-index-icon-wrapper">
        {/* <img src="/images/vivacom/landing/prp.svg" alt="vivacom-index-icon-prp" className="vivacom-index-icon" /> */}
        <img src="/images/vivacom/landing/prp_icon_discount.svg" alt="vivacom-index-icon-prp" className="vivacom-index-icon" />
        <div className="product-hr-vivacom" />
      </div>
    )
  },
  {
    product: "MTN",
    image: (
      <div className="is-flex is-align-items-center is-justify-content-center h-100 is-flex-direction-column is-primary-color">
        <img src="/images/vivacom/landing/mtn.svg" alt="vivacom-index-icon-mtn" className="vivacom-index-icon" />
        <div className="product-hr-vivacom" />
      </div>
    )
  },
  {
    product: "EXT",
    image: (
      <div className="is-flex is-align-items-center is-justify-content-center h-100 is-flex-direction-column is-primary-color">
        <img src="/images/vivacom/landing/ext.svg" alt="vivacom-index-icon-ext" className="vivacom-index-icon" />
        <div className="product-hr-vivacom" />
      </div>
    )
  }
];

const productMenuIcons = [
  { product: "GO", image: <IconGO className="navbar-icon" /> },
  { product: "CSC", image: <IconCSC className="navbar-icon" /> },
  { product: "TRA", image: <IconTRA className="navbar-icon" /> },
  { product: "PRP", image: <IconPRP className="navbar-icon" /> },
  { product: "MTN", image: <IconMTN className="navbar-icon" /> },
  { product: "EXT", image: <IconEXT className="navbar-icon" /> }
];

const tenantSettings = {
  defaultSEO: {
    title: "Vivacom",
    description: "Виваком застраховане",
    lang: "bg"
  },
  showMetaDataAndSchemas: false,
  showJsonLdSchemas: false,
  companyName: "Vivacom",
  websiteName: "Vivacom Insurance",
  companyNameFull: '"Vivacom Онлайн застраховки"',
  companyURL: "https://insurance.vivacom.bg/",
  defaultPaymentProvider: "FIBANK",
  isAppleGooglePayActive: false,
  couriers: ["econt"],
  pagesSEO: () => [
    {
      pageName: "/",
      title: "Виваком онлайн застраховки - Гражданска отговорност",
      description: "Погрижи се за бъдещето с лесна и сигурна онлайн застраховка от Vivacom. Получаваш полицата веднага по имейл и уведомления за изтичаща застраховка.",
      keywords: "онлайн застраховки, виваком застрахователен брокер, виваком застраховки, vivacom online insurance",
      canonical: "/",
      image: "boleron/product/product_card_viva_all.jpg"
    },
    {
      pageName: "/grazhdanska-otgovornost-online/",
      title: "Гражданска отговорност - поръчай и плати онлайн",
      description: "Застраховка Гражданска отговорност: Защитава ви от правни и финансови последици, когато вашите действия причиняват вреда на други. За отговорен живот.",
      keywords: "Vivacom Online Insurance, Виваком онлайн застраховки,онлайн гражданска, сравнение цени гражданска",
      canonical: "grazhdanska-otgovornost-online/",
      image: "boleron/product/product_card_viva_go.jpg"
    },
    // {
    //   pageName: "/grazhdanska-otgovornost/",
    //   title: "Данни за МПС",
    //   description: "Данни за МПС",
    //   keywords: "",
    //   canonical: "grazhdanska-otgovornost/",
    //   image: "boleron/product/product_card_viva_go.jpg"
    // },
    {
      pageName: "/kasko-kalkulator/",
      title: "Автокаско калкулатор - сравняваш оферти бързо и сигурно",
      description: "Комплексна автомобилна застраховка, покриваща щети от катастрофи, кражби и природни бедствия, осигуряваща пълна защита на вашия автомобил само с Vivacom.",
      keywords: "Vivacom Online Insurance, Виваком онлайн застраховки,онлайн автокаско, електронна полица автокаско, сравни цените автокаско",
      canonical: "kasko-kalkulator/",
      image: "boleron/product/product_card_viva_csc.jpg"
    },
    {
      pageName: "/planinska-zastrahovka/",
      title: "Планинска застраховка - разходи за спасяване",
      description:
        "Повишете защитата си с покритие за приключения на открито, ски и планинарство. Защита срещу рискове при дейности на голяма надморска височина с Виваком онлайн застраховки.",
      keywords: "Vivacom Online Insurance, Виваком онлайн застраховки,застраховка планинска, разходка в планината, разходи за спасяване, ПСС",
      canonical: "planinska-zastrahovka/",
      image: "boleron/product/product_card_viva_mtn.jpg"
    },
    {
      pageName: "/zastrahovka-ekstremni-sportove/",
      title: "Застраховка екстремни спортове",
      description: "Изживейте тръпката в безопасност с Vivacom. Покритие за любителско практикуване на дейности като скално катерене, ски и сноуборд, планиско колоездене и др.",
      keywords: "Vivacom Online Insurance, Виваком онлайн застраховки,застраховка екстремни спортове, планинска застраховка с покритие екстремен спорт",
      canonical: "zastrahovka-ekstremni-sportove/",
      image: "boleron/product/product_card_viva_ext.jpg"
    },
    {
      pageName: "/zastrahovka-imushtestvo/",
      title: "Застраховки на движимо и недвижимо имущество",
      description: "Застраховка Имущество, гарантира финансови средства за възстановяване на дома след бедствия. Защитете дома си онлайн с Vivacom.",
      keywords: "Vivacom Online Insurance, Виваком онлайн застраховки,застраховка на имущество, застраховка на къща, застраховка на апартамент",
      canonical: "zastrahovka-imushtestvo/",
      image: "boleron/product/product_card_viva_prp.jpg"
    },
    {
      pageName: "/zastrahovka-patuvane-v-chuzhbina/",
      title: "Mедицинска застраховка за пътуване чужбина",
      description: "Защитете здравето си, докато сте на почивка или бизнес пътуване в чужбина с покритие за медицинска помощ, включително и КОВИД 19 - Vivacom онлайн застраховки.",
      keywords: "Vivacom Online Insurance, Виваком онлайн застраховки,застраховка за пътуване в чужбина,застраховка при пътуване,застраховка пътуване",
      canonical: "zastrahovka-patuvane-v-chuzhbina/",
      image: "boleron/product/product_card_viva_tra.jpg"
    },
    {
      pageName: "/login-without-pass/",
      title: "Моят профил - Вход",
      description: "Достъп до Вашия профил във Vivacom Online Insurance",
      keywords: "",
      canonical: "login-without-pass/"
    },
    {
      pageName: "/documents/",
      title: "Документи",
      description: "Списък с документи и сертификати към онлайн платформа за застраховане - Vivacom Online Insurance",
      keywords: "",
      canonical: "documents/"
    }
  ]
};

export default {
  mainProducts,
  onlineProducts,
  productImages,
  productMenuIcons,
  header,
  footer,
  marketingText,
  messenger: false,
  tenantSettings,
  isCustomCarPriceEnabled: false,
  isForeignerEnabled: false,
  isUnregisteredVehicleEnabled: false,
  chatBotEnabled: false
};
